import { DeleteOutlined, DoubleRightOutlined, PlusCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { Input, Layout, Spin, message } from "antd";
import Sider from "antd/es/layout/Sider";
import { Content } from "antd/es/layout/layout";
import { withMotion } from "app/hooks/withMotion";
import { ReactComponent as EditIcon } from "assets/images/icons/edit.svg";
import clsx from "clsx";
import { FORM_MODE } from "constant";
import { useBoolean, useGetParamsUrl, useHandleSubmitApi, useSetValue } from "hook";
import { IGetCatePostOutputModel } from "interfaces";
import { ContextModule } from "models";
import { useEffect, useState } from "react";
import { Outlet, createSearchParams, useNavigate, useOutletContext } from "react-router-dom";
import { PAGE_ROUTE } from "constant/routes/page";
import { PostServices } from "services";
import CatePostModal from "./CatePostModal";
import ModalConfirm from "app/components/ConfirmExit";

const PostPresenter = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const { search, pathname } = window.location;
  const dataParams = useGetParamsUrl<{ "cate-post": string }>(search);

  const outlet = useOutletContext<ContextModule>();
  const pageRoute = outlet.pageRoute || null;

  const [optCatePost, setOptCatePost] = useState<IGetCatePostOutputModel[]>([]);
  const [catePost, setCatePost, removeCateService] = useSetValue<IGetCatePostOutputModel>();
  const [catePostRemove, setCatePostRemove, removeCateServiceRemove] = useSetValue<IGetCatePostOutputModel>();
  const [visibleCatePostForm, startVisibleCatePostForm, stopVisibleCatePostForm] = useBoolean();

  useEffect(() => {
    if (pathname === PAGE_ROUTE.ADM_POST) {
      getListCatePost();
    }

    //eslint-disable-next-line
  }, [pathname]);

  const [getListCatePost, loading] = useHandleSubmitApi(async () => {
    const dataRes = await PostServices.getCatePost();
    if (dataRes) {
      if (dataRes.data && dataRes.data.length) {
        setOptCatePost(dataRes.data);
        activeCate();

        // const matchSlug = dataRes.data.find((d) => d.slug === search);
        // if (!matchSlug) {
        //   activeCate(dataRes.data[0].slug);
        // }
      }
    }
  });

  const [handleDeleteCategory] = useHandleSubmitApi(async (catePostId: string) => {
    const dataRes = await PostServices.deleteCatePost(catePostId);
    if (dataRes) {
      message.success("Xoá danh mục thành công");
      return getListCatePost();
    }
  });

  const activeCate = (slug?: string) =>
    navigate({
      pathname: PAGE_ROUTE.ADM_POST,
      search: slug
        ? createSearchParams({
            "cate-post": slug,
          }).toString()
        : "",
    });

  const maxSizeCate = optCatePost?.length < 3;

  return (
    <Layout className="sub-layout-protected">
      {!pageRoute.hideSidebar && (
        <Sider
          className="sub-sidebar"
          collapsedWidth={20}
          trigger={null}
          collapsible
          collapsed={collapsed}
          theme="light"
          width={300}
        >
          <div className="sub-sidebar__header">
            <div className="d-flex items-center justify-space-between">
              <span>Danh mục</span>
              {!!maxSizeCate && (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    startVisibleCatePostForm();
                  }}
                >
                  <PlusCircleOutlined color="#cfd5e1" />
                </span>
              )}
            </div>
            <Input className="mt_1" placeholder="Search by Name" suffix={<SearchOutlined />} />

            <div className="sub-sidebar__header__toggle" onClick={() => setCollapsed(!collapsed)}>
              <DoubleRightOutlined style={{ fontSize: 12, color: "#6C778D" }} rotate={collapsed ? 0 : 180} />
            </div>
          </div>

          <div className="sub-sidebar__menu">
            <div
              className={clsx({ "sub-sidebar__menu__item": true, active: !dataParams?.["cate-post"] })}
              onClick={() => activeCate()}
            >
              <div className="sub-sidebar__menu__item-icon"></div>
              <div className="sub-sidebar__menu__item-text">
                <span className="ml_0-5 text-overflow-2-lines">Toàn bộ danh mục</span>
              </div>
            </div>
            {loading && (
              <div className="d-flex items-center justify-center" style={{ width: "100%", marginTop: "10rem" }}>
                <Spin size="large" />
              </div>
            )}
            {!loading &&
              optCatePost.map((i, idx) => {
                return (
                  <div
                    key={idx}
                    className={clsx({ "sub-sidebar__menu__item": true, active: dataParams?.["cate-post"] === i.slug })}
                    onClick={() => activeCate(i.slug)}
                  >
                    <div className="sub-sidebar__menu__item-icon"></div>
                    <div className="sub-sidebar__menu__item-text">
                      <span className="ml_0-5 text-overflow-2-lines">{i.name}</span>
                    </div>
                    <div className="sub-sidebar__menu__item-action d-flex pr_1">
                      <EditIcon
                        style={{ flex: "0 0 32px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCatePost(i);
                          startVisibleCatePostForm();
                        }}
                      />
                      {false && (
                        <DeleteOutlined
                          style={{ color: "#cfd5e1" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCatePostRemove(i);
                          }}
                        />
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </Sider>
      )}

      <Layout className="sub-layout-protected">
        <Content>
          <Outlet />
        </Content>
      </Layout>

      {!!visibleCatePostForm && (
        <CatePostModal
          catePost={catePost}
          onClose={() => {
            removeCateService();
            stopVisibleCatePostForm();
          }}
          mode={catePost ? FORM_MODE.EDIT : FORM_MODE.CREATE}
          onConfirm={() => {
            stopVisibleCatePostForm();
            getListCatePost();
            removeCateService();
          }}
        />
      )}

      {!!catePostRemove && (
        <ModalConfirm
          visible={!!catePostRemove}
          title={`Bạn có chắc chắn muốn xoá "${catePostRemove.name}"?`}
          cancel={() => removeCateServiceRemove()}
          confirm={() => {
            handleDeleteCategory(catePostRemove.id);
            removeCateServiceRemove();
          }}
        />
      )}
    </Layout>
  );
};

export default withMotion(PostPresenter);
